import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00e676',
      light: '#66ffa6',
      dark: '#00c853',
      contrastText: '#06110b'
    },
    secondary: {
      main: '#ff6d00',
      light: '#ff9e40',
      dark: '#e65100',
      contrastText: '#ffffff'
    },
    info: {
      main: '#00d9ff'
    },
    background: {
      default: '#070812',
      paper: 'rgba(255,255,255,0.06)'
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255,255,255,0.72)'
    }
  },
  shape: {
    borderRadius: 14
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 800 },
    h2: { fontWeight: 800 },
    h3: { fontWeight: 700 }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background:
            'radial-gradient(1200px 700px at 20% -10%, rgba(0,217,255,0.25), transparent 55%),' +
            'radial-gradient(900px 600px at 90% 10%, rgba(255,109,0,0.18), transparent 55%),' +
            'radial-gradient(900px 700px at 60% 120%, rgba(0,230,118,0.16), transparent 55%),' +
            '#070812'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(7, 8, 18, 0.94)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(255,255,255,0.08)'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 700
        },
        contained: {
          boxShadow: 'none'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(255,255,255,0.10)',
          backgroundImage:
            'linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0.04) 70%)',
          transition: 'transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease',
          '&:hover': {
            transform: 'translateY(-3px)',
            borderColor: 'rgba(0,230,118,0.35)',
            boxShadow: '0 18px 45px rgba(0,0,0,0.35)'
          }
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0c0e1c',
          backgroundImage: 'none',
          border: '1px solid rgba(255,255,255,0.12)'
        }
      }
    }
  }
})
